import type { SetupPaymentMethodResponse } from '../../../services/customer/types';
import { assertIsValueString } from '../../../utils/asserts/assertIsValueString';

export const getPaymentMethodIdFromSetupPaymentMethodResponse = (
  setupPaymentMethodResponse: SetupPaymentMethodResponse,
) => {
  assertIsValueString(
    setupPaymentMethodResponse.data.paymentMethodId,
    'Failed to add payment method',
  );

  return setupPaymentMethodResponse.data.paymentMethodId;
};
